export const getErrorMessageFromResponse = (error: any, defaultMessage: string) => {
    const errorMessage = error.response?.data?.message || defaultMessage;
    const fieldsErrors = error.response?.data?.errors || [];
    const fieldsErrorMessages = fieldsErrors
        .map((fieldError: any) => `${fieldError.field}: ${fieldError.message}`)
        .join('; ');

    return `${errorMessage}. ${fieldsErrorMessages}`;
};
